
import {Component,  Input,  OnInit} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { uploadCommand } from 'src/app/interfaces/action-command';
import { Multimedia } from 'src/app/interfaces/multimedia';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionCommandService } from 'src/app/services/action-command.service';
import { FileUploadService } from 'src/app/services/fileupload.service';
import { ObjectionService } from 'src/app/services/objection.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from 'rxjs';

export function minArrayLength(min: number) {
  return (c: AbstractControl): { [key: string]: any } => {
    if (c.value.length >= min) return null;

    return { minLengthArray: { valid: false } };
  };
}

export interface FileUploadFormData {
  images: Multimedia[];
}


@Component({
    selector: 'app-file-uploader-form',
    templateUrl: './file-uploader-form.component.html',
    styleUrl: './file-uploader-form.component.scss',
    standalone: false
})


export class FileUploaderFormComponent extends UnsubscriberComponent implements OnInit  {

  @Input() public uploadDocumentType: string;
  @Input() public path: string;
  @Input() public id: string;
  @Input() public claimId: string;
  @Input() public invoiceId: string;
  @Input() public testId: number = null;
  @Input() public DocumentId: string;
  @Input() public onClose: () => void;
  @Input() public maxFiles: number = 0; // 0 = unlimited
  @Input() public allowedExtensions: string[] = ['pdf', 'jpg', 'jpeg', 'png', 'msg', 'bmp', 'eml', 'gif'];

  public fileUploadForm: UntypedFormGroup;
  public submitting: boolean = false;
  public form: UntypedFormGroup;
  public copiedArray: Multimedia[]

  constructor(
      protected modal: NgbActiveModal,
      protected fb: UntypedFormBuilder,
      private FileUploadservice: FileUploadService,
      private Objectionservice: ObjectionService,
      private commandService: ActionCommandService,
      private toastrService: ToastrService,
    
  ) {
    super();
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      images: [[], [minArrayLength(1)]],
    });
}

  public closeModal(success: boolean = false): void {
    if (this.onClose) {
      this.onClose();  // Trigger the callback to refresh the parent
    }
    this.modal.close(success ? "success" : "closed");  
}

public handleFileUpload(): void {
  // Disable the button immediately to prevent multiple clicks
  this.submitting = true;

  if (!this.copiedArray || this.copiedArray.length === 0) {
    this.toastrService.error("Please select at least one document.");
    this.closeModal(); // Close the modal if validation fails
    this.submitting = false;
    return; // Exit the method
  }
  NProgress.start();

  // Upload every selected file, then register each uploaded mediaId
  this.subscriptions.add(
    this.FileUploadservice.uploadFiles(this.copiedArray, this.path).subscribe(
      (mediaIds: any[]) => {
        if (!mediaIds || mediaIds.some(mediaId => !mediaId)) {
          this.toastrService.error("Something went wrong, please upload files afterwards.");
          this.submitting = false;
          this.closeModal();
          NProgress.done();
          return;
        }

        const registrations: Observable<any>[] = this.copiedArray.map(
          (file, index) => this.registerUploadedFile(file, mediaIds[index])
        );

        forkJoin(registrations).subscribe({
          next: () => {
            this.submitting = false;
            NProgress.done();
            this.closeModal(this.uploadDocumentType === 'penalty');
          },
          error: () => {
            this.toastrService.error("Could not submit data");
            this.submitting = false;
            NProgress.done();
          }
        });
      },
      () => {
        this.submitting = false;
        this.closeModal();
        NProgress.done();
      }
    )
  );
}

private registerUploadedFile(file: Multimedia, mediaId: any): Observable<any> {
  if (this.uploadDocumentType === 'objection') {
    return this.Objectionservice.postObjectionDocuments(this.id, {
      type: "FILE",
      fileName: file.fileName,
      mediaId: mediaId,
      textContent: "",
      description: ""
    });
  }

  if (this.uploadDocumentType === 'penalty') {
    const uploadAdditional: any = {
      waitForExecution: true,
      messageType: 'CORE_FILE_CREATE',
      message: {
        "mediaId": mediaId,
        "fileName": file.fileName,
        "name": file.fileName,
        "Name": file.fileName,
        "FileName": file.fileName,
        "type": "FILE",
        "provider": "AzureStorageProvider",
        "idName": "InvoiceId",
        "id": this.invoiceId
      },
      "idName": "InvoiceId",
      "id": this.invoiceId,
      "testId": this.testId
    };
    return this.commandService.sendCommand2(uploadAdditional);
  }

  const post: uploadCommand = {
    waitForExecution: true,
    messageType: 'CORE_DOCUMENT_IN_RETURN',
    message: {
      returnedDate: new Date(),
      documentId: this.DocumentId,
      media: {
        mediaId: mediaId,
        name: file.fileName,
        provider: "AzureStorageProvider"
      }
    },
    idName: "InvoiceId",
    id: this.invoiceId,
    testId: this.testId
  };
  return this.commandService.sendCommand2(post);
}

  public onImagesChanged(images: Multimedia[]) {
    this.copiedArray = [...images];
  }
}